import { render, staticRenderFns } from "./SingleColumnFormBlock.vue?vue&type=template&id=30f912a2"
import script from "./SingleColumnFormBlock.vue?vue&type=script&lang=js"
export * from "./SingleColumnFormBlock.vue?vue&type=script&lang=js"
import style0 from "./SingleColumnFormBlock.vue?vue&type=style&index=0&id=30f912a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports